import React from 'react';
import './App.css';
import ExplainedForm from './ExplainedForm.js';
import Header from './Header.js'
import './css/bootstrap.min.css'

function App() {
  return (
    <div className="App">
      <Header />
      <div className="content">
        <ExplainedForm />
      </div>

    </div>
  );
}

export default App;
